import { render, staticRenderFns } from "./DiagnosticForm.vue?vue&type=template&id=0881d90c&"
import script from "./DiagnosticForm.vue?vue&type=script&lang=js&"
export * from "./DiagnosticForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports